<template>
  <div
    class="tw:absolute tw:top-1/2 tw:left-1/2 tw:-translate-x-1/2 tw:-translate-y-1/2 tw:w-48 tw:h-1 tw:bg-white/20 tw:rounded-full tw:-z-10"
  >
    <div
      class="tw:h-full tw:w-full tw:bg-white/60 tw:rounded-full tw:origin-left tw:transition-transform tw:duration-400 tw:ease-out"
      :style="{ transform: `scaleX(${progress})` }"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
  currentStepIndex: number;
  totalSteps: number;
}>();

const progress = computed(() => props.currentStepIndex / (props.totalSteps - 1));
</script>
